var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: _vm.currentCompany.companyName + " : Placed Bids" } },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.loadBids()
                }
              }
            },
            [_vm._v("refresh")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "xs12" },
            [
              _vm.isMobile
                ? _c(
                    "v-layout",
                    { staticClass: "xs12", attrs: { column: "" } },
                    [
                      !_vm.bids.length
                        ? _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        value: true,
                                        color: "primary",
                                        type: "info"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              No bids yet\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.bids, function(bid) {
                        return _c(
                          "v-card",
                          { key: bid.id, staticClass: "xs12 my-2" },
                          [
                            _c(
                              "v-tabs",
                              [
                                _c("v-tab", { attrs: { ripple: "" } }, [
                                  _vm._v(" Details ")
                                ]),
                                _vm._v(" "),
                                _c("v-tab", { attrs: { ripple: "" } }, [
                                  _vm._v(" Modify ")
                                ]),
                                _vm._v(" "),
                                _c("v-tab", { attrs: { ripple: "" } }, [
                                  _vm._v(" Map ")
                                ]),
                                _vm._v(" "),
                                _c("v-tab", { attrs: { ripple: "" } }, [
                                  _vm._v(" Conversation ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-tab-item",
                                  { key: 1 },
                                  [
                                    _c(
                                      "v-card-title",
                                      [
                                        _c(
                                          "v-layout",
                                          { attrs: { column: "" } },
                                          [
                                            _c("v-flex", [
                                              _c("b", [_vm._v("From:")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("originName")(
                                                      bid.listing
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("b", [_vm._v("To:")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("destinationName")(
                                                      bid.listing
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("v-flex", [
                                              _c("p", { staticClass: "mb-0" }, [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(bid.amount) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-italic font-weight-light"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        ($" +
                                                        _vm._s(
                                                          _vm.getPerDistanceCost(
                                                            bid
                                                          )
                                                        ) +
                                                        "/" +
                                                        _vm._s(
                                                          _vm.siteDistanceMeasureUnitLabel
                                                        ) +
                                                        ")\n                      "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      { staticClass: "pt-0" },
                                      [
                                        _c("b", [_vm._v("Loads:")]),
                                        _vm._v(" " + _vm._s(bid.numberOfLoads)),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("b", [_vm._v("Pickup Time:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatDate")(
                                                bid.pickupTime
                                              )
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("b", [_vm._v("Placed:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatDate")(bid.modified)
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { staticClass: "pt-2" },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: { "justify-center": "" }
                                              },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: _vm.getChipColor(
                                                        bid.status
                                                      ),
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.convertBidStatusToText(
                                                            bid.status
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: { "justify-center": "" }
                                              },
                                              [
                                                _vm.hasW9(bid)
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          color: "green",
                                                          "text-color": "white"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "company-profile.vendor-tax-document"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { right: "" }
                                                          },
                                                          [_vm._v("check")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm.canAcceptBid(
                                                      bid.listing
                                                    )
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          color: "orange",
                                                          "text-color": "white"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Missing " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "company-profile.vendor-tax-document"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: { right: "" }
                                                          },
                                                          [_vm._v("warning")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card-title",
                                      {
                                        staticClass: "pb-2 pt-2",
                                        attrs: { "primary-title": "" }
                                      },
                                      [
                                        _c("h4", [_vm._v("Listing Company: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              bid.listing.listingCompany.name
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-container",
                                      [
                                        _c("bid-form", {
                                          attrs: {
                                            hideMapAndConversation: "",
                                            "hide-form": _vm.hideForm,
                                            "disable-form": _vm.disableForm,
                                            bid: bid
                                          },
                                          on: {
                                            refresh: function($event) {
                                              return _vm.$emit("refresh")
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tab-item",
                                  { staticClass: "pa-3", attrs: { lazy: "" } },
                                  [
                                    _c("load-map", {
                                      attrs: {
                                        "disable-zoom": !_vm.signedIn,
                                        "origin-place-id": _vm._.get(
                                          bid,
                                          "listing.pickupLocation.googlePlace.placeId",
                                          null
                                        ),
                                        "destination-place-id": _vm._.get(
                                          bid,
                                          "listing.dropoffLocation.googlePlace.placeId",
                                          null
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tab-item",
                                  { staticClass: "pa-3" },
                                  [
                                    _c("bid-conversation", {
                                      attrs: { "bid-id": bid.id }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-master-detail-pane",
                            [
                              _c(
                                "template",
                                { slot: "master" },
                                [
                                  _c("v-load-nav-list", {
                                    attrs: {
                                      title: "Bids",
                                      searchPrompt: "Search",
                                      loading: _vm.loadingBids,
                                      accurateSince: _vm.accurateSince,
                                      loads: _vm.bids,
                                      company: _vm.currentCompany
                                    },
                                    on: {
                                      "update:searchTerm": function($event) {
                                        _vm.search = $event
                                      },
                                      refresh: function($event) {
                                        return _vm.loadBids(
                                          _vm.currentCompany.id
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "loadTile",
                                        fn: function(ref) {
                                          var idx = ref.idx
                                          var bid = ref.load
                                          return [
                                            _c(
                                              "v-list-tile",
                                              {
                                                key:
                                                  "bid_" + idx + "_" + bid.id,
                                                class: {
                                                  "primary lighten-1": _vm.isSelected(
                                                    bid
                                                  )
                                                },
                                                attrs: {
                                                  inactive: _vm.isSelected(bid),
                                                  ripple: "",
                                                  avatar: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.select(bid)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      {
                                                        staticClass:
                                                          "text--primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        $" +
                                                            _vm._s(bid.amount) +
                                                            "\n                        "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-italic font-weight-light"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        ($" +
                                                                _vm._s(
                                                                  _vm.getPerDistanceCost(
                                                                    bid
                                                                  )
                                                                ) +
                                                                "/" +
                                                                _vm._s(
                                                                  _vm.siteDistanceMeasureUnitLabel
                                                                ) +
                                                                ")\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-italic font-weight-light"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.convertBidStatusToText(
                                                                    bid.status
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-sub-title",
                                                      [
                                                        _c("b", [
                                                          _vm._v("From:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "originName"
                                                              )(bid.listing)
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("b", [
                                                          _vm._v("To:")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "destinationName"
                                                              )(bid.listing)
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-divider", {
                                              key:
                                                "bid_divider_" +
                                                idx +
                                                "_" +
                                                bid.id
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                { slot: "detail" },
                                [
                                  _vm.selected
                                    ? _c("bid-details", {
                                        attrs: { bid: _vm.selected }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39886e2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39886e2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/PlacedBids.vue
// module id = null
// module chunks = 